export { MedicalCardRegistry } from './MedicalCardRegistry';
